import * as e from "react";
import { forwardRef as o } from "react";
const C = o(function(r, t) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M5.12717 6.18818L17.8126 18.8741C17.4196 19.2071 17.0041 19.5011 16.5728 19.7561L4.24518 7.42804C4.50018 6.99675 4.79418 6.58122 5.12717 6.18818ZM6.18766 5.12759C6.5752 4.799 6.98994 4.50391 7.4274 4.24551L19.755 16.5736C19.5 17.0049 19.206 17.4197 18.873 17.8135L6.18766 5.12759ZM8.86514 3.56144C12.0616 2.37634 15.7951 3.06715 18.3638 5.63613C20.9325 8.20436 21.624 11.9389 20.4383 15.1357L8.86514 3.56144ZM3.56119 8.86517L15.1351 20.4387C11.9394 21.6238 8.20514 20.9323 5.63717 18.364C3.06769 15.7965 2.3762 12.062 3.56119 8.86592V8.86517Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  C as Cricket
};
